export default "__VITE_ASSET__3def4abc__"